import styled from "styled-components";

import { colors, zIndex } from "src/assets/styles/settings";

export const BottomSheetContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.modal};
  display: flex;
  align-items: flex-end;
  justify-content: center;

  &.c-bottom-sheet-show {
    opacity: 1;
    pointer-events: auto;
    transition: opacity 0.2s ease-in;
  }

  &.c-bottom-sheet-hide {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease-out;
    transition-delay: 0.2s;
  }

  @media (min-width: 768px) {
    // Show bottom sheet as modal dialog on Desktop devices
    justify-content: center;
    align-items: center;
  }
`;

export const BottomSheetOverlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  inset: 0;
`;

export const BottomSheetDialog = styled.div`
  background: ${colors.white};
  border-radius: 16px 16px 0 0;
  max-height: 80vh;
  max-width: var(--c-max-width);
  width: 100%;
  z-index: ${zIndex.sheet};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 16px 20px;

  .c-bottom-sheet-show & {
    transform: translateY(0);
    transition: all 0.3s ease-in;
  }

  .c-bottom-sheet-hide & {
    transform: translateY(100%);
    transition: all 0.3s ease-out;
  }

  & > * {
    flex-shrink: 0;
  }

  @media (min-width: 768px) {
    // Show bottom sheet as modal dialog on Desktop devices
    border-radius: 16px;
  }
`;

export const DialogHeader = styled.div`
  width: 100%;
  padding: 14px;
  margin: -16px -16px 0;
`;

export const DialogBody = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding: 0;
  position: relative;
`;

export const CloseButton = styled.button`
  background: transparent;
  color: ${colors.dark_smoke};
  font-size: 20px;
  border: 0;
`;

export const BottomSheetContentAutoFlow = styled.div`
  overflow-y: auto;
  flex: 1 1 0%;
  padding: 0 6px;
  margin: 0 -6px;

  &[aria-disabled="true"] {
    opacity: 0.5;
  }
`;
